import Backbone from 'backbone'

const NavItemModel = Backbone.Model.extend({
    defaults: {
        name: null,
        url: null,
        school: null,
        type: [],
        role: [],
        handheld: false,
    }
})

export default NavItemModel
